import { Component, ElementRef, Injector, Input, NgZone, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogConfig } from 'src/modules/base/components/dialog/dialog-config';
import { DialogRef } from 'src/modules/base/components/dialog/dialog-ref';
import { DialogService } from 'src/modules/base/components/dialog/dialog.service';
import { CommonViewerComponent } from 'src/modules/base/components/viewer/common-viewer/common-viewer.component';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { AsideBarService } from 'src/modules/base/services/asideBar.service';
import { CommunicationService } from 'src/modules/base/services/communication.service';
import { FilterService } from 'src/modules/base/services/filter.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { ModalService } from 'src/modules/base/services/modal.service';
import { SmartModalService } from 'src/modules/base/services/smart-modal.service';
import { UtilService } from 'src/modules/base/services/util.service';
import { UtilitiesService } from 'src/modules/base/services/utilities.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { AuthenticationService } from 'src/modules/base/shared/services/authentication.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { PreferenceService } from 'src/modules/base/shared/services/preference.service';
import { PrintService } from 'src/modules/base/shared/services/print.service';
import { RolePermissionService } from 'src/modules/base/shared/services/role-permission.service';
import { StorageService } from 'src/modules/base/shared/services/storage.service';
@Component({
    selector: 'app-mobile-card-template-view',
    templateUrl: './mobile-card-template-view.component.html',
    styleUrls: ['./mobile-card-template-view.component.scss'],
    standalone: false
})

export class MobileCardTemplateViewComponent extends CommonViewerComponent {
  headerField: any;
  subHeaderField: any;
  OtherField: any;
  @Input() resourceName: any;
  @Input() item: any;
  showIcon: boolean;
  constructor(
    public baseService: BaseService,
    public elementRef: ElementRef,
    public ngZone: NgZone,
    public route: ActivatedRoute,
    public storageService: StorageService,
    public loader: LoaderService,
    public appService: AppService,
    public asideBarService: AsideBarService,
    public preferenceService: PreferenceService,
    public alerts: AlertsService,
    public modalService: ModalService,
    public smartModalService: SmartModalService,
    public dialogService: DialogService,
    public router: Router,
    public authenticationService: AuthenticationService,
    public utilService: UtilService,
    public filterService: FilterService,
    public communicationService: CommunicationService,
    public rolePermissionService?: RolePermissionService,
    public injector?: Injector,
    public dialogConfig?: DialogConfig,
    public dialogRef?: DialogRef,
    public printService?: PrintService,
    public utilitiesService?: UtilitiesService) {
    super(baseService, elementRef, ngZone, route, storageService, loader, appService, asideBarService, preferenceService, alerts, modalService, smartModalService, dialogService, router, authenticationService, utilService, filterService, communicationService, rolePermissionService, injector, dialogConfig);
  }

  ngOnInit(): void {
    this.baseService.getResourceDef(this.resourceName, (resouceDef) => {
      if (resouceDef.config != undefined && resouceDef.config.catalogue_code != undefined) {
        this.archiveConfig.catalogue_code = resouceDef.config.catalogue_code;
      }
      if (resouceDef.list.mobile_card_view_Field) {
        this.headerField = resouceDef.list.mobile_card_view_Field.heading
        this.subHeaderField = resouceDef.list.mobile_card_view_Field.sub_heading
        this.OtherField = resouceDef.list.mobile_card_view_Field.other_fields
      }
      super.ngOnInit();
    })

  }


  getValue(item: any, field: any) {
    item = this.item;
    var format = field.format;
    if (field.type === 'array') {
      let val = [];
      if (item[field.name] && item[field.name] != undefined) {
        let arrayItem = item[field.name][0];
        let e = eval(format)(arrayItem);
        val.push(e);
      }
      return val;
    }
    if (field.type === 'advanceText') {
      if (item[field.name] != undefined && item[field.name].length != undefined && item[field.name].length > 0) {
        return item[field.name];
      }
    }
    if (field.type === 'composite' && (field.class == "_card-sub-heading" || field.class_conditions)) {
      try {
        if (item)
          return eval(format)(item);
        else
          return '';
      } catch (e) {
        ;
        return ''
      }
    }
    if (field.type === 'datetime') {
      try {
        const val = item[field.name];
        return [val ? this.utilService.dateTimeFormat(val) : ''];
      } catch { return ['']; }
    }

    if (field.type === 'composite' && field.format) {
      let val = [];
      const source = field.name ? item[field.name] : item;
      if (source !== undefined) {
        try {
          const formatFn = eval(field.format) as (x: any) => string;
          let e = formatFn(source);
          if (e === undefined || e === null) {
            e = "";
            if (field.icon) this.showIcon = true;
          }
          val.push(e);
        } catch (err) {
          console.error("Format evaluation failed:", err);
          val.push("");
        }
      }
      return val;
    }
    if (field.type === 'advanceCompositeText' && field.format) {
      try {
        const fn = eval('(' + field.format.replace(/^fn=/, '') + ')');
        const status = fn(item); // Draft / Final
        const text = field.name.split(',').filter(k => k.trim() !== 'status').map(k => item[k] || '').join(' ').trim();
        return {
          text,
          status
        };
      } catch {
        return { text: '', status: '' };
      }
    }

    if (!field.type) {
      let val = [];
      if (item[field.name] != undefined) {
        let e = item[field.name] === 'undefined' ? "" : item[field.name]
        val.push(e);
      }
      return val;
    }
  }
}
